import { lazy } from 'react';
import { HasAccess } from 'modules/auth/components/HasAccess';
import {
  EAccountPermissions,
  EPermission,
} from 'modules/auth/context/permify/permify.interfaces';
import { DashboardLayout } from '../../../app/components';
import { routingPath } from '../../../app/routes';
import { HasProfileAccess } from 'modules/auth/components/HasProfileAccess';

const ProductsMain = lazy(() =>
  import('../pages/ProductsMain').then((m) => ({ default: m.ProductsMain })),
);
const ProductDetail = lazy(() =>
  import('../pages/ProductDetail').then((m) => ({ default: m.ProductDetail })),
);
const ApplicationRequest = lazy(() =>
  import('../pages/ApplicationRequest').then((m) => ({
    default: m.ApplicationRequest,
  })),
);
const ApplicationDetails = lazy(() =>
  import('../pages/ApplicationDetails').then((m) => ({
    default: m.ApplicationDetails,
  })),
);
const QualificationRequest = lazy(() =>
  import('../pages/QualificationRequest').then((m) => ({
    default: m.QualificationRequest,
  })),
);
const ContractDetails = lazy(() =>
  import('../pages/ContractDetails').then((m) => ({
    default: m.ContractDetails,
  })),
);

const ProductRoutes = () => {
  return {
    element: <DashboardLayout />,
    children: [
      {
        path: routingPath.products.main,
        element: (
          <HasAccess permission={EPermission.PRODUCTS_LIST}>
            <ProductsMain />
          </HasAccess>
        ),
      },
      {
        path: routingPath.products.detail,
        element: <ProductDetail />,
      },
      {
        path: routingPath.products.applicationRequest,
        element: (
          <HasProfileAccess permission={EAccountPermissions.CREATE_APPLICATION}>
            <ApplicationRequest />
          </HasProfileAccess>
        ),
      },
      {
        path: routingPath.products.applicationDetails,
        element: (
          <HasAccess permission={EPermission.PRODUCTS_APPLICATIONS_VIEW}>
            <ApplicationDetails />
          </HasAccess>
        ),
      },
      {
        path: routingPath.qualification.new,
        element: (
          <HasProfileAccess
            permission={EAccountPermissions.CREATE_PERSON_BUSINESS}
          >
            <QualificationRequest />
          </HasProfileAccess>
        ),
      },
      {
        path: routingPath.products.contractsDetails,
        element: <ContractDetails />,
      },
    ],
  };
};

export default ProductRoutes;
